import { headingTagsOverlap } from './heading-common';

export default function () {
  const el = document.querySelector('.article-heading-wrapper');
  if (!el) return;

  headingTagsOverlap();
}
